import { render, staticRenderFns } from "./bonus11.vue?vue&type=template&id=80118a88&scoped=true&"
import script from "./bonus11.vue?vue&type=script&lang=js&"
export * from "./bonus11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80118a88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80118a88')) {
      api.createRecord('80118a88', component.options)
    } else {
      api.reload('80118a88', component.options)
    }
    module.hot.accept("./bonus11.vue?vue&type=template&id=80118a88&scoped=true&", function () {
      api.rerender('80118a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/bonusConfig/bonus11.vue"
export default component.exports